import { ImmutableQuery } from 'services';
import { Device } from 'types';

const DeviceUtils = {
  /** Returns filtered array of devices */
  filterDevicesByIds: (allCollection: Device[], deviceIds: string[]) =>
    deviceIds.length
      ? allCollection.filter((device) => deviceIds.includes(device.id))
      : [],
  /** Returns boolean indicating if device is not in array */
  curryDevicesFilter: (devices: Device[]) => (device: Device) =>
    devices.findIndex((item) => item.id === device.id) === -1,
  /** Returns devices whose hash contains search string */
  filterDevices: (devices: Device[], searchInput: string) =>
    !searchInput
      ? devices
      : devices.filter((device) =>
          DeviceUtils.hashDevice(device).includes(searchInput.toLowerCase()),
        ),

  /** Returns device's ID */
  getId: (device: Device) => device.deviceIdForSinglePage,

  /** Given a device ID in form `<type>:<number>, returns device's ID number */
  getNumberFromId: (id = ''): string => id.substr(id.indexOf(':') + 1),

  /**
   * Returns the ids of the devices in the first array that have matching ids
   * with the devices in the second array.
   * Ctapi: ids:"dedicated:0234567"
   * BpitApi ids:"234567", resourceID: "dedicated:0234567"
   * We can't assume that the  Bpit Ids === Ctapi Ids - "dedicated:"
   */
  getOverlappingIds: (
    bpitDevices: Device[] = [],
    ctDevices: Device[] = [],
  ): string[] => {
    const cIds = ctDevices.map((cD) => cD.id);
    return bpitDevices
      .filter((bpitDevice) => cIds.includes(bpitDevice.resourceID || ''))
      .map((bD) => bD.id);
  },

  /** Return a search string primed function to identify matching devices  */
  hashDevice: (device: Device) => {
    const {
      id = '',
      location = '',
      name = '',
      network: { addresses = [] },
      platform = '',
      type = '',
    } = device;
    const primary = addresses.find((item) => item.primary);
    const address = primary ? primary.value : '';
    return `${id} ${address} ${location} ${name} ${platform} ${type}`
      .replace(/  +/g, ' ')
      .trim()
      .toLowerCase();
  },

  /** Convert 'text' query param to 'q' */
  textToQ: (query: ImmutableQuery) =>
    query.set({ q: query.get('text') || null, text: null }),
};

export { DeviceUtils };
